import { Button } from '@latitude/button';
import { Icon } from '@latitude/icons';
import React from 'react';

type NavigationProps = {
  onNext: () => void;
  onPrevious: () => void;
  isNextDisabled?: boolean;
  isPreviousDisabled?: boolean;
};

export const Navigation: React.FC<NavigationProps> = ({
  onNext,
  onPrevious,
  isNextDisabled,
  isPreviousDisabled,
}) => {
  return (
    <div className="ml-auto mt-6">
      <Button
        htmlType="button"
        variant="neutral"
        type="ghost"
        leadingElement={
          <Icon name="chevron-left" title="Chevron" direction="left" />
        }
        onClick={onPrevious}
        disabled={isPreviousDisabled}
        data-testid="navigation-previous"
      />
      <Button
        htmlType="button"
        variant="neutral"
        type="ghost"
        leadingElement={
          <Icon name="chevron-left" title="Chevron" direction="right" />
        }
        onClick={onNext}
        disabled={isNextDisabled}
        data-testid="navigation-next"
      />
    </div>
  );
};
